import { jsPDF } from 'jspdf';

function fmtDate(s) {
  if (!s) return '—';
  try { return new Date(s).toLocaleDateString('en-SG', { day: 'numeric', month: 'long', year: 'numeric' }); }
  catch { return s; }
}

export function generateContractPDF(d) {
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });
  const W = 210, ml = 20, mr = 20, cw = W - ml - mr;
  let y = 20;

  const chk = (need) => { if (y + need > 275) { doc.addPage(); y = 20; } };
  const ln = (n = 5) => { y += n; };

  // ── Cover / Main Agreement ──────────────────────────────────────────────
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(13);
  doc.text('SOFT GLOW COMMERCIAL AGREEMENT', W / 2, y, { align: 'center' }); ln(6);
  doc.setFontSize(10);
  doc.text('("COMMERCIAL AGREEMENT")', W / 2, y, { align: 'center' }); ln(10);

  doc.setDrawColor(180); doc.setLineWidth(0.3);
  doc.line(ml, y, W - mr, y); ln(8);

  doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
  const intro = `SOFT GLOW PTE. LTD. (UEN: 202424661Z), a company incorporated under the laws of Singapore, having its principal place of business at 57 Ubi Avenue 1 #03-09, Ubi Centre, Singapore 408936 ("Soft Glow"), enters into this Agreement with the Customer as stated in Schedule 1.`;
  const introLines = doc.splitTextToSize(intro, cw);
  doc.text(introLines, ml, y); y += introLines.length * 4.5; ln(6);

  const sectionTitle = (t) => {
    chk(12);
    doc.setFont('helvetica', 'bold'); doc.setFontSize(9);
    doc.text(t, ml, y);
    doc.setDrawColor(200); doc.line(ml, y + 1.5, W - mr, y + 1.5); ln(7);
  };

  const clause = (num, text) => {
    chk(14);
    doc.setFont('helvetica', 'bold'); doc.setFontSize(9); doc.text(`${num}.`, ml, y);
    doc.setFont('helvetica', 'normal');
    const lines = doc.splitTextToSize(text, cw - 7);
    doc.text(lines, ml + 7, y); y += lines.length * 4.5; ln(2);
  };

  const subClause = (letter, text) => {
    chk(10);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
    const lines = doc.splitTextToSize(text, cw - 14);
    doc.text(`(${letter})`, ml + 7, y); doc.text(lines, ml + 14, y);
    y += lines.length * 4.5; ln(1);
  };

  sectionTitle('1. PRODUCTS & DEFINITIONS');
  clause('1', '"Products" means the range of Revitalash cosmetic and hair care products bearing the brands/trademarks set out in Schedule 1 that Soft Glow supplies to the Customer, following orders placed by the Customer ("Order(s)").');

  sectionTitle('2. SALE OF PRODUCTS');
  clause('2', "Every Customer's Order is subject to the terms of this Commercial Agreement and Soft Glow's General Terms of Sales in Schedule 2. In the event of any conflict, the main body of this Agreement shall prevail.");
  clause('3', "Soft Glow may reject an Order at its discretion, including cases of product unavailability or unusually high order volumes.");
  clause('4', 'Products are not sold on a "Sale or Return" basis. Products may not be returned without Soft Glow\'s prior written consent and official collection arrangement.');
  clause('5', "The Customer shall sell Products in their original, unaltered packaging only, and shall not sell Products outside the Republic of Singapore.");
  clause('6', "Customer shall not authorise any third person to do any act that would damage or be inconsistent with the Trademarks or service marks used by Soft Glow in connection with the Products.");

  sectionTitle('3. DELIVERY, PAYMENT & PORTAL ACCESS');
  clause('7', "Products shall be invoiced in Singapore Dollars in accordance with the current price-list. Soft Glow reserves the right to modify its price list with one (1) month's prior written notice.");
  clause('8', `The Customer's credit term for payment is ${d.creditTerm} days from the date of Soft Glow's invoice. Accepted payment methods include ${d.paymentMethod}.`);
  clause('9', "Risk in the Products passes to the Customer on delivery. Title remains with Soft Glow until the Customer has paid in full all sums due.");
  clause('10', "Upon delivery, the Customer shall inspect and acknowledge receipt. Any discrepancy, defect or damage must be notified in writing within 7 working days of receipt. After this period, Products are deemed accepted.");
  clause('11', "Where Soft Glow provides portal access to the Customer, such access is non-transferable and tied to the Customer's account. Soft Glow may suspend or revoke access immediately upon non-payment or breach. The Customer is responsible for maintaining the confidentiality of its login credentials.");

  sectionTitle('4. LIABILITY & WARRANTY');
  clause('12', "Soft Glow excludes all warranties as to quality or fitness for purpose, whether express or implied, to the fullest extent permitted by law.");
  clause('13', "Soft Glow shall not be liable for any loss of profit, loss of business, indirect, special or consequential loss, howsoever caused, arising out of or in connection with any Order or this Agreement.");

  sectionTitle('5. CONFIDENTIALITY');
  clause('14', "The Customer shall not disclose any confidential information of Soft Glow, including pricing, product information and trade terms, and shall use such information solely to perform its obligations under this Agreement.");

  sectionTitle('6. TERM AND TERMINATION');
  clause('15', `This Agreement shall be effective from ${fmtDate(d.startDate)} for a period of ${d.duration || 12} months, expiring on ${fmtDate(d.endDate)}, unless terminated earlier. Soft Glow may terminate this Agreement at any time upon sixty (60) days' prior written notice.`);
  clause('16', "Soft Glow may terminate this Agreement with immediate effect, cancel or suspend any Order, or withhold deliveries if the Customer:");
  subClause('a', 'fails to pay any amounts due by the due date;');
  subClause('b', 'commits a material breach and fails to remedy it within thirty (30) days of written notice; or');
  subClause('c', 'becomes insolvent, is wound up, or has a receiver or administrator appointed.');

  sectionTitle('7. FORCE MAJEURE');
  clause('17', 'If Soft Glow is prevented or delayed from performing its obligations by any cause outside its reasonable control (including acts of God, pandemic, government action, fire, flood, or supply chain disruption) ("Force Majeure Event"), Soft Glow may suspend or cancel the relevant Orders without liability.');

  sectionTitle('8. MISCELLANEOUS');
  clause('18', "The Customer warrants that its signatory is duly authorised to sign this Agreement and bind the Customer.");
  clause('19', "Soft Glow may assign or novate this Agreement. The Customer may not assign, novate or transfer this Agreement without Soft Glow's prior written consent.");
  clause('20', "This Agreement constitutes the entire agreement between the Parties and supersedes all prior agreements relating to its subject matter.");
  clause('21', "This Agreement shall be governed by the laws of the Republic of Singapore. The Parties submit to the exclusive jurisdiction of the courts of Singapore.");

  // ── Signatures ─────────────────────────────────────────────────────────
  chk(60);
  doc.setDrawColor(180); doc.line(ml, y, W - mr, y); ln(8);
  doc.setFont('helvetica', 'bold'); doc.setFontSize(9);
  doc.text('SIGNATURES', W / 2, y, { align: 'center' }); ln(8);

  const hw = (cw - 10) / 2;
  doc.setFont('helvetica', 'bold');
  doc.text('Signed for and on behalf of', ml, y);
  doc.text('Signed for and on behalf of', ml + hw + 10, y); ln(5);
  doc.text('SOFT GLOW PTE. LTD.', ml, y);
  doc.text((d.custName || '[CUSTOMER]').toUpperCase(), ml + hw + 10, y); ln(12);
  doc.setDrawColor(120); doc.setLineWidth(0.3);
  doc.line(ml, y, ml + hw, y);
  doc.line(ml + hw + 10, y, ml + hw + 10 + hw, y); ln(5);
  doc.setFont('helvetica', 'normal');
  doc.text(`Name: ${d.sgSigName || 'Sheng Weijie'}`, ml, y);
  doc.text(`Name: ${d.custSigName || '_____________________'}`, ml + hw + 10, y); ln(5);
  doc.text(`Title: ${d.sgSigTitle || 'Director'}`, ml, y);
  doc.text(`Title: ${d.custSigTitle || '_____________________'}`, ml + hw + 10, y); ln(5);
  doc.text('Date: _________________', ml, y);
  doc.text('Date: _________________', ml + hw + 10, y); ln(14);

  // ── Schedule 1 ─────────────────────────────────────────────────────────
  doc.addPage(); y = 20;
  doc.setFont('helvetica', 'bold'); doc.setFontSize(11);
  doc.text('SCHEDULE 1 — SOFT GLOW TRADE TERMS', W / 2, y, { align: 'center' }); ln(10);

  const tableRow = (label, value, shade) => {
    chk(10);
    if (shade) { doc.setFillColor(247, 246, 243); doc.rect(ml, y - 4, cw, 9, 'F'); }
    doc.setFont('helvetica', 'bold'); doc.setFontSize(8.5); doc.text(label, ml + 2, y);
    doc.setFont('helvetica', 'normal');
    const vLines = doc.splitTextToSize(String(value || '—'), cw * 0.55);
    doc.text(vLines, ml + cw * 0.42, y);
    y += Math.max(vLines.length * 4.5, 7); ln(1);
  };

  tableRow('Customer Registered Name', d.custName, true);
  tableRow('Customer Registration Number', d.custUen, false);
  tableRow('Product Brand(s)', 'Revitalash', true);
  tableRow('Credit Term', `${d.creditTerm} days`, false);
  tableRow('Payment Methods', d.paymentMethod, true);
  tableRow('Portal Access', 'Yes — tied to Customer account', false);
  tableRow('Billing Address', [d.billing?.street1, d.billing?.street2, d.billing?.city, d.billing?.zip, d.billing?.country].filter(Boolean).join(', ') || '—', true);
  tableRow('Commencement Date', fmtDate(d.startDate), false);
  tableRow('Expiry Date', fmtDate(d.endDate), false);
  if (d.discount) tableRow('Structural Discount', `${d.discount}%`, true);

  ln(6);
  doc.setDrawColor(180); doc.line(ml, y, W - mr, y); ln(6);
  doc.setFont('helvetica', 'bold'); doc.setFontSize(9);
  doc.text('Approved Points of Sale', ml, y); ln(7);

  if (!d.pos?.length) {
    doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5);
    doc.text('No points of sale specified.', ml, y); ln(6);
  } else {
    d.pos.forEach((p, i) => {
      if (i % 2 === 0) { doc.setFillColor(247, 246, 243); doc.rect(ml, y - 4, cw, 8, 'F'); }
      doc.setFont('helvetica', 'bold'); doc.setFontSize(8.5); doc.text(p.name, ml + 2, y);
      doc.setFont('helvetica', 'normal'); doc.text(p.addr || '—', ml + cw * 0.42, y); ln(8);
    });
  }

  // ── Schedule 2 ─────────────────────────────────────────────────────────
  doc.addPage(); y = 20;
  doc.setFont('helvetica', 'bold'); doc.setFontSize(11);
  doc.text('SCHEDULE 2 — GENERAL TERMS OF SALE', W / 2, y, { align: 'center' }); ln(10);

  const gts = [
    ['1. DEFINITION', 'In these General Terms of Sale, "Company" means Soft Glow Pte. Ltd. (UEN: 202424661Z). "Customer" means the person, firm or company buying Products from the Company. "Order" means the written instruction placed by the Customer to supply the Products.'],
    ['2. SCOPE', 'Any Order implies full and unconditional acceptance of these General Terms of Sale. No variation shall be valid unless accepted in writing by an authorised officer of Soft Glow.'],
    ['3. ORDER', 'All Orders are accepted subject to availability. Soft Glow reserves the right to withdraw products or cease an Order before transportation.'],
    ['4. PRICE', "Prices are fixed by the current price-list. Each Order will be invoiced at the price applicable on the day the Order was placed. Soft Glow reserves the right to revise its price-list with one (1) month's prior notice."],
    ['5. PAYMENT', `Standard payment term is ${d.creditTerm} days from invoice. Accepted payment methods: ${d.paymentMethod}. Payment in Singapore Dollars (SGD). Interest on overdue amounts at 1.5% per month.`],
    ['6. PORTAL ACCESS', "Portal access is non-transferable and tied to the Customer's account. Soft Glow may suspend or revoke access for non-payment or breach."],
    ['7. DELIVERY', 'Transportation costs are borne by Soft Glow. Delivery times are estimates only and do not entitle the Customer to cancel or claim damages for delay.'],
    ['8. INSPECTION & CLAIMS', 'Any discrepancy, defect or damage must be reported within 7 working days of receipt. After this period, Products are deemed accepted.'],
    ['9. NO RETURN', 'Products are not sold on a "Sale or Return" basis. No returns without prior written authorisation from Soft Glow.'],
    ['10. RISK AND TITLE', 'Risk passes to the Customer on delivery. Title remains with Soft Glow until full payment is received.'],
    ['11. NO ALTERATION & EXPORT', 'The Customer shall not alter product packaging. Products shall be sold exclusively to end consumers within Singapore and shall not be exported.'],
    ['12. CONFIDENTIALITY', 'The Customer shall keep confidential all pricing, product information and trade terms of Soft Glow.'],
    ['13. FORCE MAJEURE', "If Soft Glow is prevented from performing its obligations by any cause outside its reasonable control, performance of the relevant Order shall be suspended or cancelled without liability."],
    ['14. TERMINATION', 'Soft Glow may cancel, suspend or terminate any contract and decline further deliveries if the Customer defaults on payment, commits a material breach, or becomes insolvent.'],
    ['15. GOVERNING LAW', 'These General Terms of Sale are governed by the laws of Singapore. Any disputes shall be subject to the exclusive jurisdiction of the Courts of Singapore.'],
  ];

  gts.forEach((item, i) => {
    chk(16);
    if (i % 2 === 0) { doc.setFillColor(247, 246, 243); doc.rect(ml, y - 4, cw, 9, 'F'); }
    doc.setFont('helvetica', 'bold'); doc.setFontSize(8.5);
    const hLines = doc.splitTextToSize(item[0], cw * 0.3);
    doc.text(hLines, ml + 2, y);
    doc.setFont('helvetica', 'normal');
    const vLines = doc.splitTextToSize(item[1], cw * 0.62);
    doc.text(vLines, ml + cw * 0.36, y);
    y += Math.max(hLines.length * 5, vLines.length * 5) + 2; ln(1);
  });

  ln(8);
  doc.setFont('helvetica', 'italic'); doc.setFontSize(8);
  doc.text('The above General Terms of Sale cancel and supersede all previous versions.', W / 2, y, { align: 'center' }); ln(5);
  doc.text('Soft Glow Pte. Ltd. (UEN: 202424661Z) | 57 Ubi Avenue 1 #03-09, Ubi Centre, Singapore 408936', W / 2, y, { align: 'center' });

  return doc;
}

export function downloadPDF(doc, custName) {
  const safeName = (custName || 'Customer').replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '');
  doc.save(`SoftGlow_Agreement_${safeName}.pdf`);
}

export function getPDFBlob(doc) {
  return doc.output('blob');
}
